export function substringUserName(user) {
    if (user && user.lastName && user.firstName)
        return user.firstName.substring(0,1) + user.lastName.substring(0,1)
    else if (user && user.lastName)
        return user.lastName.substring(0,2).toUpperCase()
    else
        return ''
}

export function formatTimestamp(d) {
    return ("0" + d.getDate()).slice(-2) + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" +
    d.getFullYear() + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2)
}

/** Тексты правил для полей ФИО */
export const FIO_ALLOWED_MESSAGE = 'В ФИО разрешены только кириллица, дефис и пробел.'
export const FAMILIA_ALLOWED_MESSAGE = 'В фамилии разрешены только кириллица, дефис и пробел'
export const IMYA_ALLOWED_MESSAGE = 'В имени разрешены только кириллица, дефис и пробел'
export const OTCHESTVO_ALLOWED_MESSAGE = 'В отчестве разрешены только кириллица, дефис и пробел'

/** Только кириллица, дефис и пробел (фамилия / имя) */
export const FIO_PATTERN = /^[А-Яа-яЁё\- ]+$/

/** То же для отчества: пустое значение допустимо */
export const FIO_PATTERN_OPTIONAL = /^$|^[А-Яа-яЁё\- ]+$/

/**
 * Проверка части ФИО: разрешены кириллица, дефис и пробел.
 * @param {string|null|undefined} value
 * @param {{ allowEmpty?: boolean }} [options] — allowEmpty: true для необязательного отчества
 * @returns {boolean}
 */
export function isValidFioPart(value, { allowEmpty = false } = {}) {
    if (value == null || String(value).trim() === '') {
        return !!allowEmpty
    }
    return FIO_PATTERN.test(String(value).trim())
}

/**
 * Проверяет корректность ИНН по контрольной сумме
 * @param {string|number} inn - Проверяемый ИНН
 * @returns {boolean} - true, если ИНН валиден
 */
export const isInnChecksumValid = (inn) => {
    if (!inn) return false;

    const strInn = String(inn).trim();

    // Проверка на длину (10 или 12 цифр) и отсутствие лишних символов
    if (!/^\d{10}$|^\d{12}$/.test(strInn)) {
        return false;
    }

    const digits = strInn.split('').map(Number);

    // Функция для вычисления контрольной цифры
    const getCheckDigit = (digitsArray, coefficients) => {
        let sum = 0;
        for (let i = 0; i < coefficients.length; i++) {
            sum += digitsArray[i] * coefficients[i];
        }
        return (sum % 11) % 10;
    };

    if (digits.length === 10) {
        // Проверка 10-значного ИНН (Юрлица)
        const coefficients = [2, 4, 10, 3, 5, 9, 4, 6, 8];
        const checkDigit = getCheckDigit(digits, coefficients);
        return checkDigit === digits[9];
    }

    if (digits.length === 12) {
        // Проверка 12-значного ИНН (Физлица)
        const coefficients11 = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8];
        const coefficients12 = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8];

        const checkDigit11 = getCheckDigit(digits, coefficients11);
        const checkDigit12 = getCheckDigit(digits, coefficients12);

        return checkDigit11 === digits[10] && checkDigit12 === digits[11];
    }

    return false;
};
